import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Icon } from '@appcues/sonar-builder';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import Button from './Button';
import { Truncated } from './Text';

const Label = styled(Truncated)`
  max-width: 200px;
  padding-right: 10px;
`;

interface DropdownButtonProps {
  children?: React.ReactNode;
  onClick?: () => void;
}

const DropdownButton = forwardRef<HTMLButtonElement, DropdownButtonProps>(
  ({ children, onClick }, ref) => (
    <Button onClick={onClick} ref={ref}>
      <Label>{children}</Label>
      <Icon icon={faChevronDown} />
    </Button>
  )
);

DropdownButton.displayName = 'DropdownButton';

export default DropdownButton;
